module.exports = __webpack_public_path__ + "static/media/lingshoudianERP.5af65632.png";